<template>
  <v-autocomplete
    :id="keyUpTargetId"
    v-model="selectedOptionValue"
    :items="modelList"
    clearable
    hide-no-data
    hide-selected
    return-object
    :loading="laborerLoading"
    :search-input.sync="searchLaborer"
    item-value="id"
    :error="searchLaborer && searchLaborer.length < 2"
    :append-icon="laborerLoading ? '' : 'search'"
    item-text="querySearch"
    :label="label"
    persistent-hint
    :hint="getHint"
    :outlined="outlined"
    :hide-details="hideDetails"
    :dense="dense"
    @click:append="onSearchLaborer"
    @click:clear="onClear"
    @change="onLaborerSelectorFilterChange"
  >
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        small
        @click="data.select"
        @click:close="onRemove"
      >
        <v-avatar
          v-if="data.item.avatar && data.item.avatar.id"
          left
        >
          <v-img :src="data.item.avatar.path" />
        </v-avatar>
        {{ data.item.fullName }}
      </v-chip>
    </template>
    <template v-slot:item="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-item-content v-text="data.item" />
      </template>
      <template v-else>
        <v-avatar
          v-if="data.item.avatar && data.item.avatar.id"
          left
        >
          <v-img :src="data.item.avatar.path" />
        </v-avatar>
        <v-avatar
          v-else
          color="success"
        />
        <v-list-item-content class="ml-2">
          <v-list-item-title>
            {{ data.item.fullName }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ `${data.item.username} ${data.item.city ? `(${data.item.city})` : '' }` }}
            <span
              v-if="data.item.workerType === 'wt-self-employed'"
              style="color: #FF9800 !important;"
            >СМЗ</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'WBDLaborerListFilterComponent',
  props: {
    label: {
      type: String,
      default: 'Поиск пользователей по ФИО, ИНН, СНИЛС, Почте, Тел'
    },
    remoteList: {
      type: Array,
    },
    laborerNumId: {
      type: String,
    },
    boarded: {
      type: Boolean,
    },
    isSelfEmployed: {
      type: Boolean,
    },
    outlined: {
      type: Boolean,
    },
    hideDetails: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    isAsynchronous: {
      type: Boolean,
      default: false, // true for async search, false for sync search
    },
  },
  data () {
    return {
      keyUpTargetId: 'laborerListFilterEltRef',
      laborerLoading: false,
      searchLaborer: null,
      modelList: [],
      selectedOptionValue: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
    getHint () {
      if (this.isSelfEmployed) {
        return 'Поиск только СМЗ'
      }
      if (this.boarded) {
        return 'Поиск только активированных'
      }

      return undefined
    }
  },
  watch: {
    searchLaborer (newSearch) {
      if (this.isAsynchronous) {
        this.onSearchLaborer()
      } else {
        this.modelList = []
      }
    },
    remoteList: {
      immediate: true,
      handler (newValue) {
        if (newValue && newValue.length) {
          this.modelList = newValue
          this.selectedOptionValue = newValue[0]
        }
      },
    },
  },
  async created () {
    // if (this.remoteList && this.remoteList.length) {
    //   this.modelList = this.remoteList
    //   this.selectedOptionValue = this.remoteList[0]
    // }

    if (this.laborerNumId) {
      this.searchLaborer = this.laborerNumId
      await this.onSearchLaborer()
    }
    this.eventsBus.$on(this.eventNames.LABORER_LIST_FILTER_RESET, this.onClear)
  },
  mounted () {
    window.addEventListener('keyup', (event) => {
      if (!(event && event.target && event.target.id === this.keyUpTargetId)) {
        return
      }
      if (event.keyCode === 13) {
        event.preventDefault()
        this.onSearchLaborer()
      }
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    async onSearchLaborer () {
      if (!this.laborerLoading && this.searchLaborer && this.searchLaborer.length > 2) {
        this.modelList = []
        this.laborerLoading = true
        const params = { 'searchQuery': this.searchLaborer, 'page[number]': 1, 'page[size]': 50, 'isSearch': 1 }
        if (this.boarded) {
          params.onboarded = '1'
        }
        if (this.isSelfEmployed) {
          params.isSelfEmployed = '1'
        }

        try {
          // getLaborerList
          const list = await this.$store.dispatch(
            'user/getLaborerList',
            { params }
          )
          setTimeout(() => {
            this.laborerLoading = false
          }, 1500)
          this.modelList = list.data.map((item) => ({
            ...item,
            querySearch: this.searchLaborer
          }))

          if (this.laborerNumId && this.modelList.length === 1) {
            this.selectedOptionValue = this.modelList[0]
            this.onLaborerSelectorFilterChange()
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.laborerLoading = false
        }
      }
    },

    onClear () {
      this.selectedModelList = null
      this.modelList = []
      this.searchQuery = null
    },
    onRemove () {
      this.selectedOptionValue = null
      this.$emit(
        'onLaborerSelectorFilterChange',
        null,
        null
      )
    },
    onLaborerSelectorFilterChange () {
      this.$emit(
        'onLaborerSelectorFilterChange',
        this.selectedOptionValue ? this.selectedOptionValue.id : null,
        this.selectedOptionValue
      )
    },
  }
}
</script>
